/**
 * Copyright (c) 2024, Mohamed eRrais (merrais / MeR)
 * merrais@tech2us.ma
 * محمد الرايس
 * Tech2us
 */

import {useState, useEffect, useLayoutEffect} from 'react'
import {Button} from 'react-bootstrap'
import './meTable.css'
import Api, {Read, Fetch} from '../Shared/Api'
import {icons} from '../../config/app'
import {ToFormat} from  'fast_inon'
import {meResults} from '../Shared/meLayout'
import {ColorsOptions} from '../Shared/ColorsControl'


const TableView = ({node, onChange, onParent, onPage, Message, role=1, request}) => {

    const [editable, Edit] = useState('false')
    const [fields, Fields]= useState([])
    const [items, Items]= useState([])
    const [clicked, Clicked] = useState({n:0,x:0,y:0,now:new Date()})
    const [selected, Select] = useState({...node, parent:0, field:'', value:''}) // cell
    const [style, Style] = useState(null)
    const [loaded, Load] = useState(false)

    const resizer = new meResults(node.entity)
    const [layouts, Layouts]= useState([])
    const [colors, Colors]= useState([])

    useLayoutEffect (()=>{  
        resizer.selectorAll() 

        if(layouts.length>0) {
            layouts.forEach((item) => {
                resizer.SetStyle(item.Name, item.Coord)
            })
        }
    })

    useEffect(()=>{
        resizer.InitStyle(layouts) 
    },[layouts])

    useEffect(() => {
        Items([])

        if(node?.entity?.length>0 && node?.id>0) {
            //alert(`TableView ${request}`)  
            Api.get(request)
            .then(response => {
                if(response.data?.length>0) {
                    //alert(response.data?.length)
                    Items(response.data)
                    Fields(Object.keys(response.data[0]))
                    Load(true)
                }
            })
            .catch(error => {
                Message && Message(error)
            })

            Read(`/Layout/${node.entity}`,Layouts,null, Message)
        }

        if(items?.length>0) {
            //console.log('items',items.length); entity = {...entity, rows:items.length}
            items.forEach(item => {
                item.Checked = false
            })
        }    

    }, [node])

    const Stats = (id=0) => {
        onParent && onParent({rows:items.length, name:node.entity, id})
        
        Etat(`Stats ${node.entity}- Parent=${node.parent} = ${items.length}`)
    }

    const Etat = (message="") => {
        var etat = document.getElementById("EtatApp")
        if(etat)
            etat.innerHTML = message
    }
    
    const onRefresh = (e) => {
        Load(false)
    }

    const onSize = (e) => {
        //console.log(e, e.src)
        if(e.title==="Minimize") {
            e.title="Maximize"
            e.src=icons.maximize
        }
        else {
            e.title="Minimize"
            e.src=icons.minimize
        }
        //e.reload
        return (e.title==="Minimize") // minimized
    }

    const onAdd = (e) => {
        //alert(`Add ${entity.entity} -> ${entity.parent}`)
        if(node.entity.length>2) {
            const data = {
                Entity: node.entity,
                ParentId: node.parent, 
                Name: `New`
            }
            let route = request.slice(0, request.indexOf('/',2))
            Fetch(route, data)
            .then(item => {
                Message && Message(`${node.entity} added !`)

                onRefresh(e)
            })
        }
    }

    const onReadOnly = (object, status=true, field) => {
        /*
        if(!status && (field?.endsWith("Id") || field?.endsWith("Key"))) {
            Etat(`${field} is readOnly.`); alert(`${field} is readOnly.`)
            //Edit(false)
        }
        else */
        {
            //object.readOnly = readOnly
            Edit(status?'false':'true')

            if(status) {
                if(style) {
                    object.style = style
                }
            }
            else {
                Style(object.style)
                object.style.cursor = 'text'
                object.style.border = '1px solid blue'
                object.style.backgroundColor = 'rgba(230, 219, 155, 0.5)'
                object.style.fontWeight = 'bold'
                object.focus()
            }
            //console.log(object); alert(`readOnly ${object.readOnly}`)
        }
    }

    useEffect(()=>{
        if(selected?.field)
            Etat(`${selected.entity}-Cell : ${selected.field}-${selected.id}=${selected.value}`)
        else
            Etat()

        onChange && onChange(selected)

        //onRefresh()

        if(selected.field==='PageId') {
            onPage && onPage({PageId: selected.value})
            //alert(selected.value)
        }

    }, [selected])

    const onCell = (e, id) => {
        const object = e?.target
        if(object) {
            const field = object.title.substring(0, object.title.indexOf('= '))
            Select({...selected, id:id, field:field, value:object.innerText})

            let cr = object.getBoundingClientRect()
            if(cr && cr.right>0 && cr.bottom>0) {
                let w=parseInt(cr.right-cr.left)
                let h=parseInt(cr.bottom-cr.top)
            
        //let message= `onClick (event x ${event.clientX}, y ${event.clientY})`; console.log(message, cr, clicked)//; Now is debuging 
        
                let n = clicked.n
                let x = parseInt((e.clientX-cr.left)*100/w)||0
                let y = parseInt((e.clientY-cr.top)*100/h)||0
                let now = new Date()
        
                if(Math.abs(clicked.x-x)<3 && Math.abs(clicked.y-y)<3) {
                    let ms=now.getTime()-clicked.now.getTime()
                    if(ms<500) {
                        n=n+1
        
                        if(n>0) {  // 2 or 3 click !

                            onReadOnly(object, false, field)
                        }
                    }
                    else
                        n=0
                }
                else
                    n=0
                    
                Clicked({n,x,y,now})  
            }
        }
    }

    const toId = (item, index) => {
        const id=`Item-${item.Id}-${fields[index]}`
        return id
    }

    const onCheck = (e, id) => {
        items.filter(item=>{
            return (item.Id===id)
        })
        .map(item => { 
            item.Checked = !item.Checked

            Stats(id)
            Select({...selected, id:id, field:'Id', value:id})
            //return item.Checked
        })

        
        const td = e.target.parentElement
        if(td.tagName==='TD') {
            if (td.classList.contains('checked')) {
                td.classList.remove('checked')
            }
            else {
                td.classList.add('checked') 
            }
        }
        //console.log('onCheck', id, td.className)
    }

    // MeR 241015 ElementsLogs & BridgeSession !
    const Log = (data, object, Message, action="Entity") => {
        Fetch('/session/log', {...data, action}, object) 
        if(Message) {
            if(action==="Entity")
                Message(`${data?.entity}.${data?.id} [${data?.field}] = ${data?.value} !`)
            else if(action==="Component")
                Message(`${data?.component}.${data?.id} [${data?.element}] = ${data?.value} !`)
        }
    }

    const onUpdate = (e, byValue=false) => {
        const object = e?.target
        if(object && editable) {
            const keycode = (e.keyCode ? e.keyCode : e.which)
            //alert(`update ${keycode} - ${e.shiftKey}`)
            if (keycode === 13) {
                if (e.shiftKey) {
        
                }
                else {
                    if(role>=1) {
                        object.innerText = object.innerText.slice(0, -2)
                        if (selected?.id > 0) {
                            const data = { ...selected, entity:node.entity, value: object.innerText}
                            //alert(JSON.stringify(data))

                            let route = request.slice(0, request.indexOf('/',2))
                            Fetch(route, data, object, 'PUT') // object for the update style !
                            .then(res=>{
                                Log(data,object,Message)
                            })
                        }
                    }
                    onReadOnly(object)   
                }
                e.stopPropagation()
            }
            else if (keycode === 27) {
                object.value = object.defaultValue
                onReadOnly(object)
            }		
        }
    }

    return (
<div className="element" id={`${node.entity}Element`}>
<div className="row results-head">   
    <div className="col-sm-9"> 
        <div className="results-name">{node?.id} - {node.entity}(s)</div>
    </div>   
    <div className="col-sm-1">
        <img className="icons" src={icons.reload} alt="Refresh" onClick={(e) => onRefresh(e)} />
    </div>             
    <div className="col-sm-1">
        <img className="icons" src={icons.add} alt="Create" onClick={(e) => onAdd(e)}/>
    </div>       
    <div className="col-sm-1">
        <img className="icons" src={icons.minimize} alt={"Minimize"} title="Minimize" onClick={(e) => onSize(e)} />
    </div>             
</div>        
        
{ items?.length>0 && fields.length>0
?

<div className="results"
    onMouseDown={(e)=>{resizer.mouseDown(e)}} 
    onMouseMove={(e)=>{resizer.mouseMove(e)}} 
    onMouseUp={(e)=>{resizer.mouseUp(e)}}
>

<table className='styled-table' id={`${node.entity}Table`}>
    
<thead id={`${node.entity}Head`}>
    <tr key='Th-'>
        {
            fields.map(field=>
                <th key={`Th-${field}`} id={`Th-${field}`} entity={node.entity}>{field}</th>)
        }
    </tr>
</thead>

<tbody id={`${node.entity}Body`}>
{
    items.map((item, row) =>
        <tr id={`Row-${row}`} key={`Row-${row}`}>

{ Object.values(item).map((value,index) => (
    
    index===0 ? (
        <ToId value={value} onClick={e => onCheck(e,value)} checked={item?.Checked} />
    ) : (
        ['At','ated'].some(f=>fields[index]?.endsWith(f)) ?
        <td style={{textAlign:'right', color:'darkblue'}} key={toId(item,index)}>{ToFormat(value)}</td>
        : ['Id','Key','_','*'].some(f=>fields[index]?.endsWith(f)) ?
        <td className="editable" key={toId(item,index)}>{value}</td>
        :
        <td className="editable" contentEditable={editable} suppressContentEditableWarning={true} id={toId(item,index)} key={toId(item,index)}
            title={`${fields[index]}= ${value}`} 
            value={value}
            defaultValue={value}
            onClick={(e) => onCell(e, item.Id)} onKeyUp={e => onUpdate(e)} >
        {value}</td>
    ) 
)) }
    </tr>
            )
}
</tbody>
</table>
</div>

:
<h5>{node?.entity} are loading...</h5>
}

<div className="row results-foot">
    <div className="col-sm-3">
        <p id="EtatStat">Ready</p>
    </div>

    <div className="col-sm-6">
        <p id="EtatApp">...</p>
    </div>
    <div className="col-sm-3 results-rows">
        <p id="results-rows">{items.length} rows</p>
    </div> 
</div>  

</div>

 )
}

const ToId = ({value, onClick, crud=0, checked}) => {  
    const bstyle = { width: '2rem', display: 'block', padding:'0.2rem', textAlign:'right', border:'none' }  

    const getVariant = () => {
        let bvariant = crud>0 ?  (crud===2 ? "outline-info" : "outline-warning") : "outline-primary"
        if(checked) {
            bvariant = bvariant.replace("outline-","")
        }
        return bvariant
    }
    
    return (
<td className='Id' key={value} value={value} >
    <Button key={`Item-${value}-Id`} value={value} variant={getVariant()} 
        style={bstyle}
        onClick={(e) => onClick(e, value)}
    >{value}</Button>      
</td>
 )
}

export default TableView

